import { useAnchorable } from '../../hooks/useAnchorable';

import { container } from './FootnotesNode.css';
import type { TPostFootnotesNodeProps } from './FootnotesNode.types';

export const PostFootnotesNode = ({ element, children }: TPostFootnotesNodeProps) => {
  const { attrs } = element;
  const { anchorAttributes } = useAnchorable(attrs);

  return (
    <div {...anchorAttributes} className={container}>
      {children}
    </div>
  );
};
